export const AI_FEATURE_KEYS = Object.freeze({
  MEAL_PHOTOS_VERIFIER: 'mealPhotosVerifier',
  MEAL_DAY_ESTIMATOR: 'mealDayEstimator',
  VOICE_NOTE_TRANSCRIBER: 'voiceNoteTranscriber',
  VOICE_NOTE_VERIFIER: 'voiceNoteVerifier',
  QUESTS_PLANNER_RESCHEDULER: 'questsPlannerRescheduler',
  FORM_CHECK: 'formCheck'
});

export const VERIFICATION_MODAL_FEATURE_KEYS = Object.freeze([
  AI_FEATURE_KEYS.MEAL_PHOTOS_VERIFIER,
  AI_FEATURE_KEYS.VOICE_NOTE_TRANSCRIBER,
  AI_FEATURE_KEYS.VOICE_NOTE_VERIFIER
]);

export const getFeatureQuota = (quotaState, featureKey) => {
  if (!quotaState || !featureKey) {
    return null;
  }
  return quotaState.features?.[featureKey] || null;
};

export const isQuotaBlocked = (quota) => Boolean(quota && quota.allowed === false);

export const getQuotaMessage = (quota) => {
  if (!quota) {
    return '';
  }
  if (typeof quota.message === 'string' && quota.message.trim()) {
    return quota.message;
  }
  if (quota.limit > 0 && quota.remaining === 0) {
    return `${quota.label || 'This feature'} daily limit reached.`;
  }
  return '';
};

export const getRewardedUnlock = (quota) => quota?.rewardedAds || null;

export const canStartRewardedUnlock = (quota) => Boolean(quota?.rewardedAds?.canStart);

export const getFirstBlockedQuota = (quotaState, featureKeys) => {
  if (!Array.isArray(featureKeys)) {
    return null;
  }
  return featureKeys
    .map((featureKey) => getFeatureQuota(quotaState, featureKey))
    .find(isQuotaBlocked) || null;
};
